import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../atoms/Buttons/Button/Button";

interface ReusableModalProps {
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  onConfirm: () => void;
}

const ActionModal: React.FC<ReusableModalProps> = ({
  show,
  onClose,
  children,
  title,
  onConfirm,
}) => {
  return (
    <Modal show={show} onHide={onClose} className="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button text="Cancel" onClick={onClose} cssClass="btn-secondary " />
        <Button text="Confirm" onClick={onConfirm} cssClass="btn-primary " />
      </Modal.Footer>
    </Modal>
  );
};

export default ActionModal;
